import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// ── Persistent login shim ────────────────────────────────────────────────────
// Promote sessionStorage to localStorage so the school admin (and super admin)
// stays logged in across browser restart. JWT expiry (8h server-side) still
// enforces the real security boundary. This shim avoids touching ~72 existing
// `sessionStorage.getItem('gs_*')` call sites scattered across components.
try {
  if (typeof window !== 'undefined' && window.localStorage && window.sessionStorage) {
    // 1. Migrate any values already in sessionStorage into localStorage so the
    //    current tab's login isn't lost on first deploy.
    for (let i = 0; i < window.sessionStorage.length; i++) {
      const key = window.sessionStorage.key(i);
      if (key && window.localStorage.getItem(key) === null) {
        window.localStorage.setItem(key, window.sessionStorage.getItem(key));
      }
    }
    // 2. Make every future `sessionStorage.*` call hit localStorage instead.
    Object.defineProperty(window, 'sessionStorage', {
      configurable: true,
      value: window.localStorage,
    });
  }
} catch (e) {
  // Some private-mode browsers throw on storage access — fall back silently.
  // eslint-disable-next-line no-console
  console.warn('[storage] persistent-login shim disabled:', e && e.message);
}

// Capture beforeinstallprompt BEFORE React mounts to avoid the race condition
// where the event fires before the component's useEffect registers its listener.
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  window._deferredPwaPrompt = e;
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch(() => {});
  });
}
